export default [
  {
    path: '/accounts',
    name: 'accounts',
    component: () => import('@/views/accounts/index'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/referrer',
    name: 'Referrer',
    component: () => import('@/views/accounts/referrer-list'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/accounts/create',
    name: 'accountsCreate',
    component: () => import('@/views/accounts/create'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/accounts/detail',
    name: 'accountsDetail',
    component: () => import('@/views/accounts/detail'),
    meta: {
      keepAlive: false
    },
    children:[
      {
        path: '',
        component: () => import('@/views/accounts/components/homeTab'),
        name: 'homeTab'
      },
      {
        path: 'profile',
        component: () => import('@/views/accounts/components/profileTab'),
        name: 'profileTab'
      },
      {
        path: 'quote',
        component: () => import('@/views/accounts/components/quote'),
        name: 'quoteTab'
      },
      {
        path: 'policy',
        component: () => import('@/views/accounts/components/policies'),
        name: 'policyTab'
      },
      {
        path: 'ticket',
        component: () => import('@/views/accounts/components/tickets'),
        name: 'ticketTab'
      },
      {
        path: 'hd',
        component: () => import('@/views/accounts/components/hdMember'),
        name: 'hdTab'
      },
      {
        path: 'coupons',
        component: () => import('@/views/accounts/components/couponCategory'),
        name: 'couponsTab'
      },
      {
        path: 'referral',
        component: () => import('@/views/accounts/components/referral-request'),
        name: 'referralTab'
      },
      {
        path: 'message',
        component: () => import('@/views/accounts/components/message'),
        name: 'messageTab'
      },
      {
        path: 'upload',
        component: () => import('@/views/accounts/components/uploadRequest'),
        name: 'uploadTab'
      },
    ]
  },
  {
    path: '/accounts/insurer',
    name: 'accountsInsurer',
    component: () => import('@/views/accounts/insurer'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/insurer/accounts',
    name: 'insurerAccounts',
    component: () => import('@/views/accounts/insurer-account'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/insurer/accounts/plan',
    name: 'insurerAccountsPlan',
    component: () => import('@/views/accounts/components/insurer-plan'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
  {
    path: '/insurer/accounts/plan/detail',
    name: 'insurerAccountsPlanDetail',
    component: () => import('@/views/accounts/components/insurer-plan-detail'),
    meta: {
      keepAlive: false,
      bg_white: true
    },
    redirect: '/insurer/accounts/plan/detail/policy',
    children:[
      {
        path: 'policy',
        name: 'insurerAccountsPlanDetailPolicy',
        component: () => import('@/views/accounts/components/insurer-plan-policy')
      },
      {
        path: 'quote',
        name: 'insurerAccountsPlanDetailQuote',
        component: () => import('@/views/accounts/components/insurer-plan-quote')
      },
      {
        path: 'document',
        name: 'insurerAccountsPlanDetailDocument',
        component: () => import('@/views/accounts/components/insurer-plan-document')
      },
      {
        path: 'commission',
        name: 'insurerAccountsPlanDetailCommission',
        component: () => import('@/views/accounts/components/insurer-plan-commission')
      },
      {
        path: 'claim-method',
        name: 'insurerAccountsPlanDetailClaimMethod',
        component: () => import('@/views/accounts/components/claimMethod/index')
      },
    ]
  },
  {
    path: '/insurer/accounts/send/arbitrary/sms',
    name: 'sendArbitrarySms',
    component: () => import('@/views/accounts/sendArbitrarySms'),
    meta: {
      keepAlive: false
    }
  }
]
